/* eslint-disable react/jsx-one-expression-per-line */
import {
  DisabledTag,
  Icon,
  BackgroundIcon,
  AppContext,
  DateTimeFormatter
} from '@nile/components';
import { Tooltip } from '@superops/ui-design-system';
import dayjs from 'dayjs';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { getTimeDifference } from '@nile/projects/src/Utils';
import { FormattedMessage } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';

const DetailHolderTag = styled.div`
  display: flex;
  flex: 1 1;
  flex-direction: column;
  align-items: flex-start;
  max-width: 20%;
  .titleHolder {
    color: #00000099;
    font-size: 1.4rem;
    // font-weight: 500;
  }
  .content {
    /* margin-top: 1rem; */
    align-items: center;
    width: calc(100% - 10px);
    .value {
      color: #000000cc;
      font-size: 1.4rem;
      font-weight: 700;
      &.value-na {
        font-weight: 400;
      }
      &.value-od {
        color: #e02020;
      }
    }
  }
`;

const calculateDueDate = ({ dueDate }) => {
  const currentDate = dayjs(new Date());
  const timeDifferenceInDays = dayjs(dueDate).diff(currentDate, 'days');

  if (timeDifferenceInDays >= 1) {
    return (
      <div className="value">{Math.floor(timeDifferenceInDays)} days left</div>
    );
  }

  const timeDifferenceInMinutes = dayjs(dueDate).diff(currentDate, 'minutes');

  if (timeDifferenceInMinutes <= 0) {
    return (
      <div className="value value-od">
        <FormattedMessage id="project.details.dueDate.overdue" />
      </div>
    );
  }

  // eslint-disable-next-line radix
  const hours = parseInt(Math.floor(timeDifferenceInMinutes / 60).toString());
  const minutes = Math.round(timeDifferenceInMinutes % 60);

  if (minutes) {
    return (
      <div className="value">
        {hours} hours {minutes} mins left
      </div>
    );
  }
  return <div className="value">{hours} hours left</div>;
};

const DueHolder = ({
  title,
  icon,
  start,
  dueDate,
  overdue,
  url,
  actualEndDate
}) => {
  const appContext = useContext(AppContext);
  const { company } = appContext;

  const renderDate = () => {
    if (actualEndDate) {
      return (
        <DisabledTag>
          <DateTimeFormatter type="date" date={dueDate} />
        </DisabledTag>
      );
    }
    if (overdue) {
      return (
        <div className="value value-od">
          <FormattedMessage id="project.details.dueDate.overdue" />
        </div>
      );
    }
    if (dueDate) {
      return calculateDueDate({
        dueDate: dueDate
      });
    }
    return (
      <DisabledTag>
        <FormattedMessage id="project.details.dueDate.NA" />
      </DisabledTag>
    );
  };

  return (
    <DetailHolderTag>
      <div className="fx content">
        <Tooltip content={<div>{title}</div>}>
          <div className="opacity5">
            <SVGIcon name={icon} />
          </div>
        </Tooltip>
        <div className="ml-10">
          <Tooltip
            content={
              dueDate ? (
                <div>
                  {dayjs(dueDate).format(
                    `${company?.dateFormat ||
                      'MMM DD YYYY'}, ${company?.timeFormat || 'hh:mm A'}`
                  )}
                </div>
              ) : (
                <div>
                  <FormattedMessage id="project.details.dueDate.noEndDate" />
                </div>
              )
            }
          >
            {renderDate()}
          </Tooltip>
        </div>
      </div>
    </DetailHolderTag>
  );
};

export default DueHolder;
